import { notification } from "antd";
import { API, BASE_URLS } from "../../api";
import { InfoCircleOutlined } from "@ant-design/icons";
import { setDirectoryAccessToken, setDirectoryEligibility, setDirectoryLookUp, setDirectoryPaymentMethods, setOtpLoader } from "../../redux/directory";

export function LookUpDirectory(params) {
  return async function (dispatch) {
    try {
      const { data: { entity } } = await API.post(
        `${BASE_URLS.DIRECTORY_LOOKUP}`,
        {
          phoneNumber: params?.phoneNumber || '',
          name: params?.name || '',
          email: params?.email || '',
        }
      );
      if (entity?.status === 'NOT_FOUND'){
        dispatch(setDirectoryEligibility(false));
      } else {
        dispatch(setDirectoryLookUp(entity));
      }
    } catch (e) {
      notification.open({
        placement: "topRight",
        duration: 10,
        className: "custom-warning-notification",
        icon: <InfoCircleOutlined className="custom-warning-icon" />,
        message: (
          <span className="custom-warning-text">
            {e?.response?.data?.message ||
              "Unable to process request. Please try again later"}
          </span>
        ),
      });
    }
  };
}

export function OnLoadOtp(params) {
  return async function (dispatch) {
    try {
      const { data: { entity } } = await API.post(
        `${BASE_URLS.DIRECTORY_AUTHENTICATE}`,
        {
          phoneNumber: params?.phoneNumber || '',
          name: params?.name || '',
          email: params?.email || '',
        }
      );
      dispatch(setDirectoryLookUp(entity));
    } catch (e) {
      notification.open({
        placement: "topRight",
        duration: 10,
        className: "custom-warning-notification",
        icon: <InfoCircleOutlined className="custom-warning-icon" />,
        message: (
          <span className="custom-warning-text">
            {e?.response?.data?.message ||
              "Unable to process request. Please try again later"}
          </span>
        ),
      });
    }
  };
}

export function OtpValidate(params) {
  return async function (dispatch) {
    dispatch(setOtpLoader(true));
    try {
      const { data: { entity } } = await API.post(
        `${BASE_URLS.DIRECTORY_VERIFY_OTP}`,
        params,
      );
      dispatch(setDirectoryAccessToken(entity?.token?.accessToken));
      dispatch(RetriveDirectoryPaymentMethods({
        accessToken: entity?.token?.accessToken,
        ...params,
      }));
      dispatch(setOtpLoader(false));
    } catch (error) {
      notification.open({
        placement: "topRight",
        duration: 10,
        className: "custom-warning-notification",
        icon: <InfoCircleOutlined className="custom-warning-icon" />,
        message: (
          <span className="custom-warning-text">
            {error?.data?.message ||
              "Unable to process request. Please try again later"}
          </span>
        ),
      });
      dispatch(setOtpLoader(false));
    }
  };
}

export function ResendOtp(params) {
  return async function (dispatch) {
    dispatch(setOtpLoader(true));
    try {
      const { data: { entity } } = await API.post(
        `${BASE_URLS.DIRECTORY_RESEND_OTP}`,
        params,
      );
      if (entity?.status === 'NOT_FOUND'){
        dispatch(setDirectoryEligibility(false));
      } else {
        dispatch(setDirectoryLookUp(entity));
      }
      notification.open({
        placement: "topRight",
        duration: 5,
        className: "custom-success-notification",
        icon: <InfoCircleOutlined style={{ color: "#52c41a" }} />,
        message: "OTP send successfully!",
      });
      dispatch(setOtpLoader(false));
    } catch (error) {
      notification.open({
        placement: "topRight",
        duration: 10,
        className: "custom-warning-notification",
        icon: <InfoCircleOutlined className="custom-warning-icon" />,
        message: (
          <span className="custom-warning-text">
            {error?.data?.message ||
              "Unable to process request. Please try again later"}
          </span>
        ),
      });
      dispatch(setOtpLoader(false));
    }
  };
}

export function RetriveDirectoryPaymentMethods(params) {
  return async function (dispatch) {
  const typeParams = [];

    if (!params?.cardExist && !params?.bankExist) {
      dispatch(setDirectoryPaymentMethods([]));
      return;
    }

    if (params?.cardExist) {
      typeParams.push('type.IN=CARD');
    }

    if (params?.bankExist) {
      typeParams.push('type.IN=BANK');
    }

    const queryString = typeParams.length ? `?${typeParams.join('&')}` : '';
    try {
      const { data: { entity } } = await API.get(
        `${BASE_URLS.RETRIVE_DIRECTORY_PAYMENT_METHODS}${queryString}`,
        {
          params: {
            phoneNumber: params?.phoneNumber,
            otpId: params?.otpId,
          },
          headers: {
            'x-directory-authorization': `Bearer ${params?.accessToken}`,
          },
        }
      );
      dispatch(setDirectoryPaymentMethods(entity?.content || []));
    } catch (error) {
      notification.open({
        placement: "topRight",
        duration: 10,
        className: "custom-warning-notification",
        icon: <InfoCircleOutlined className="custom-warning-icon" />,
        message: (
          <span className="custom-warning-text">
            {error?.data?.message ||
              "Unable to process request. Please try again later"}
          </span>
        ),
      });
    }
  };
}